import React from 'react'
import { Button } from 'components'
import { useTranslation } from 'react-i18next'

import {
    Box,
    Dialog,
    Divider,
    styled,
    Typography,
    useTheme,
} from '@mui/material'
import { Icon } from 'packages/eid-icons'

const CustomDialog = styled(Dialog)({
    root: {
        maxWidth: 'unset',
    },
    '& .MuiDialog-paperWidthSm': {
        background: '#f7f8fa',
    },
    '& .MuiBox-root': {
        border: 'none',
        background: ' #f7f8fa',
        position: 'relative',
    },
})
const ModalHeader = styled(Box)({
    padding: '3.2rem 4.0rem',
    '& svg': {
        top: '-1.4rem !important',
    },
})

const CloseIconeBox = styled(Box)({
    '& svg': {
        position: 'absolute',
        top: '-2.0rem',
        right: '-2.0rem',
        cursor: 'pointer',
    },
})

const ModalFooter = styled(Box)(({ theme }) => ({
    display: 'flex',
    padding: '3.2rem 4.0rem',
    gap: '1.6rem',

    '& button': {
        border: `solid 0.1rem ${theme?.palette?.primary?.main}`,
        padding: '0.8rem 1.2rem',
        height: '3.2rem',
        fontSize: '1.4rem',
        '&:nth-child(1)': {
            background: theme?.palette?.primary?.main,
            color: '#fff',
        },
        '&:nth-child(2)': {
            color: theme?.palette?.primary?.main,
            maxWidth: '9.0rem',
        },
    },
}))

const ActionModal = ({
    headerTitle = 'Header Title',
    onSubmit,
    onClose,
    actionButtonLabel = 'Action',
    children,
    isSubmitting = false,
    disabled = false,
    ...rest
}) => {
    const theme = useTheme()
    const { t } = useTranslation()

    return (
        <CustomDialog
            minWidth={'50%'}
            maxWidth={false}
            open={true}
            onClose={onClose}
            aria-labelledby="action-modal-title"
            {...rest}
        >
            <ModalHeader>
                <CloseIconeBox
                    role="button"
                    tabIndex={0}
                    onClick={onClose}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault()
                            onClose()
                        }
                    }}
                    aria-label="Close"
                    data-ai-explain="Close this dialog"
                >
                    <Icon
                        name="Close"
                        width="1.6rem"
                        height="1.6rem"
                        color="#959598"
                    />
                </CloseIconeBox>
                <Typography
                    id="action-modal-title"
                    variant="h2"
                    fontWeight={'bold'}
                >
                    {headerTitle}
                </Typography>
            </ModalHeader>
            <Box minWidth={'50%'} padding={'0rem 4.0rem'}>
                {children}
            </Box>
            <Divider sx={{ margin: '0rem 3.2rem' }} />
            <ModalFooter>
                <Box>
                    <Button
                        backgroundColor={theme?.palette?.primary?.main}
                        onClick={onSubmit}
                        loading={isSubmitting}
                        disabled={disabled}
                        disabledStyles={{
                            backgroundColor: '#aab0b4 !important',
                            borderColor: '#aab0b4 !important',
                            color: '#ffffff !important',
                        }}
                        data-ai-explain={`Confirm: ${actionButtonLabel}`}
                    >
                        {actionButtonLabel}
                    </Button>
                </Box>

                <Button
                    onClick={onClose}
                    data-ai-explain="Cancel and close this dialog"
                >
                    {t('Cancel')}
                </Button>
            </ModalFooter>
        </CustomDialog>
    )
}

export default ActionModal
